module.exports = __webpack_public_path__ + "media/images/static/entry/mark_icon-f617f11175153ef2a12484b687704235.png";